// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: "https://apiicaa.apiitech.co.in/index.php/",
  mediaURL: 'https://apiicaa.apiitech.co.in/uploads/',
  authToken: 'icaa',
  version:9,
  playstoreurl:'',
  payumerchantkey:'6eMulj',
  payuclientid:'17eda9b6e2806356ef8bf6c66a629c99bff3fd2528036a100c7b8651cfe63abf',
  payuclientsecret:'caa1e8bd7f135eb64dae9d6c368086b900446bbdb58b781fc897771d1a917a9d',
  firebase: {
    apiKey: "AIzaSyDxLYCop7kgMKrMCjlnrlJBJWcXB1lByTU",
    authDomain: "chatapp-5e797.firebaseapp.com",
    projectId: "chatapp-5e797",
    storageBucket: "chatapp-5e797.appspot.com",
    messagingSenderId: "409361595207",
    appId: "1:409361595207:web:48ef145edd4291b956ea62",

  },
  apiUrls: {

    apis: {
      Login: 'member/Login',
      getParameterList: 'GlobalVariable/getAll',



      eventsave: 'events/save',
      editevent: 'events/editlist',
      eventall: 'events/getAll',
      deleteevent: 'events/deleteList',
      geteventid: 'events/getById',
      eventregistrationsave: 'eventregistration/save',
      editeventregistration: 'eventregistration/editlist',
      eventregistrationall: 'eventregistration/getAll',
      deleteeventregistration: 'eventregistration/deleteList',
      geteventregistrationid: 'eventregistration/getById',
      getregistrationall:'eventregistration/getregistrationall',
      getmobile:'eventregistration/getmobile',
      getotpdetails:'eventregistration/getotpdetails',
      getregistrationdetails:'eventregistration/getregistrationdetails',
      savelog:'logs/save',
      getlogreport:'logs/getlogreport',
      savelogbulk:'logs/savebulk',
      usersList:'users/getAll',
      saveusers:'users/save',
      updateusers:'users/editList',
      deleteusers:'users/deleteList',
      getusersbycode:'users/getByItemId',
      getusers:'users/getById',
      send_usercreationmail:'users/send_usercreationmail',
      saveSettings:'GlobalVariable/save',
      deleteSettings:'GlobalVariable/deleteList',
      updateSettings:'GlobalVariable/editList',
      getType:'GlobalVariable/getByType',
      
      subscriptionplansave: 'subscriptionplans/save',
      editsubscriptionplan: 'subscriptionplans/editlist',
      subscriptionplanall: 'subscriptionplans/getAll',
      deletesubscriptionplan: 'subscriptionplans/deleteList',
      getsubscriptionplanid: 'subscriptionplans/getById',
      subscriptionplans:'subscriptionplans/getsubscriptionplans',


      getimagebyid: 'images/getById',
      getimagebylimit:'images/getByLimit',

      whatsappgroupsall: 'whatsappgroups/getAll',
      getwhatsagroupbylimit:'whatsappgroups/getByLimit',

      nfoall: 'nfo/getAll',

      getInsuranceByType: 'insurance/getByType',
      getAifType: 'aif/getByType',
      getCatgeoryByType: 'category/getByType',

      contactall: 'contacts/getAll',
      comitteeall: 'commitee/getAll',
      rtaall: 'rta/getAll',
      
      bloglist:'https://advisorsindia.in/wp-json/wp/v2/posts?categories=168&_fields=title,content,date,_links&_embed',
      knowledgelist:'https://advisorsindia.in/wp-json/wp/v2/posts?categories=211&_fields=title,content,date,_links&_embed',      
      newslist:'https://advisorsindia.in/wp-json/wp/v2/posts?categories=1&_fields=title,content,date,_links&_embed',

      getCreativesBySubCategory: 'creative/getBySubCategory',
      creativecategoryall: 'creativecategory/getAll',
      getByCreativeCategory:'creativecategory/getByCategory',
      getcreativesbyid: 'creative/getById',
      
      trainingsall: 'trainings/getAll',
      getAllsponsors: 'sponsors/getall',


      getmemberotpdetails:'member/getotpdetails',
      editmember:'member/editList',
      getsubscriptionplansbytype:'subscriptionplans/getsubscriptionplansbytype',
      getPayUHash:'payment/getPayUHash',
      getmemberdetails:'member/getById',
      savemember:'member/save',
      getByPhoneNumber:'member/getByPhoneNumber',


      paymentssave: 'payments/save',
      editpayments: 'payments/editlist',
      paymentsall: 'payments/getAll',
      deletepayments: 'payments/deleteList',
      getpaymentsid: 'payments/getById',
      getPaymentByMember: 'payments/getByMember',
	  
    }

  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
